export default __webpack_public_path__ + "static/media/border.940dda76.png";